import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { LockedList } from '../non-adherence-list/non-adherence-list';
import { NonComplianceListService } from './non-compliance-list.service';
import { MatSnackBar } from '@angular/material';
import { SessionStorage } from 'ngx-webstorage';

@Component({
  selector: 'app-non-compliance-list',
  templateUrl: './non-compliance-list.component.html',
  styleUrls: ['./non-compliance-list.component.css']
})

export class NonComplianceListComponent implements OnInit {
  @SessionStorage() public user;
  public timesheetLock: LockedList[] = [];
  public selectedCheckbox: Array<any> = [];
  public totalElements = 0;
  public pageNumber = 1;
  public screenHeight: any;

  constructor(
    private nonComplianceListService: NonComplianceListService,
    private snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {
    this.getLockedList();
  }

  /**function to get locked list */
  getLockedList() {
    this.timesheetLock = [];
    this.nonComplianceListService.getLockedList().subscribe((response) => {
      this.totalElements = response.payload;
      if (response.payload && response.payload.length > 0) {
        response.payload.filter(ele => ele.lockedDetails.isNonCompliance === true).map(ele => {
          this.timesheetLock.push(new LockedList(ele));
        });
      }
    });
  }

  /**function to unlock requested employee*/
  unlockSelected(empId) {
    const employees = [];
    employees.push(empId);
    if (employees.length > 0) { // if Atleast 1 request is selected
      this.nonComplianceListService.unLockTimeSheet(employees).subscribe((response) => {
        this.snackBar.open('Unlocked selected employees Successfully', 'OK', {
          duration: 3000,
        });
        this.getLockedList();
      }, (error) => {
        this.snackBar.open('Error occured while unlocking the timesheet', 'OK', {
          duration: 3000
        });
      });
    }
  }

  /* Upon change of pagination call API again */
  triggerChange(data: any) {
    this.pageNumber = data;
    this.getLockedList();
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/non-compliance-list/non-compliance-list.component.ts